export const selectCustomers = (state) => state.customers;

export const selectCustomersList = (state) => state.customers.list;
export const selectCustomersListLoading = (state) => state.customers.loading;
export const selectCustomersListLoadingCount = (state) => state.customers.loadingCount;
export const selectCustomersListError = (state) => state.customers.error;
export const selectCustomerFilters = (state) => state.customers.filters;